import { render, staticRenderFns } from "./AddTeacher.vue?vue&type=template&id=82ab4d2a&scoped=true&"
import script from "./AddTeacher.vue?vue&type=script&lang=js&"
export * from "./AddTeacher.vue?vue&type=script&lang=js&"
import style0 from "./AddTeacher.vue?vue&type=style&index=0&id=82ab4d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ab4d2a",
  null
  
)

export default component.exports